import { URLapiParty as api } from '../../../config/api'
import {
  fetchLoans,
  deleteUser,
  countryList,
  addLoan,
  removeoperationsfromuser,
  updateuser,
  switchaccountenabled,
  getall,
} from '../../../config/ActionsPromise'
// import config from '../../../config/config.json'
const usersService = {
  get: async (userType) => {
    const { data } = await getall(userType)

    return data
  },
  createUser: async (value) => {
    const send = {
      displayName: `${value.fullname}`,
      mail: value.email,
      mobilePhone: value.phone,
      countryGroupId: value.country,
      department: value.department,
      roles: value.profile,
      position: value.position,
      organisation: value.organisation,
    }
    const { data } = await api.post('/user/create?api-version=1.0', send)
    return data
  },
  updateUser: async (value) => {
    const send = {
      userId: value.id,
      displayName: `${value.fullname}`,
      mail: value.email,
      mobilePhone: value.phone,
      country: value.country,
      department: value.department,
      roles: value.profile,
      position: value.position,
      organisation: value.organisation,
    }
    const { data } = await updateuser(send)
    return data
  },
  getOperationByUser: async (id) => {
    const data = await api.get(
      `user/getalluseroperations?UserId=${id}&api-version=1.0`,
    )
    return data
  },
  resetPassword: async (idUser) => {
    const value = { id: idUser }
    const { data } = await api.post(
      '/user/resetpassword?api-version=1.0',
      value,
    )

    return data
  },
  deleteUser: async (idUser) => {
    const value = { id: idUser }
    const data = await deleteUser(value)
    return data
  },
  getAccount: async (id) => {
    const { data } = await api.get(`user/account?UserId=${id}&api-version=1.0`)
    return data
  },
  removeoperationsfromuser: async (value) => {
    const { data } = await removeoperationsfromuser(value)
    return data
  },
  addLoan: async (value) => {
    const data = await addLoan(value)
    return data
  },
  getOperations: async (userToken) => {
    const data = await fetchLoans(userToken)
    return data
  },
  getRoles: async (appdomain) => {
    const { data } = await api.get(
      `role/list?UserType=${appdomain}&api-version=1.0`,
    )
    return data
  },
  getcountryList: async () => {
    return await countryList()
  },
  addRoles: async (listRoles) => {
    const result = await api.post(
      `user/addrolesgroupstouser?api-version=1.0`,
      listRoles,
    )
    return result
  },
  deleteRoles: async (listRoles) => {
    const result = await api.post(
      `user/removerolesgroupsfromuser?api-version=1.0`,
      listRoles,
    )
    return result
  },
  getCountries: async () => {
    const { data } = await api.get(`country/list?api-version=1.0`)
    return data
  },
  addCountries: async (listCountries) => {
    const result = await api.post(
      `user/addcountriesgroupstouser?api-version=1.0`,
      listCountries,
    )
    return result
  },
  deleteCountries: async (listCountries) => {
    const result = await api.post(
      `user/removecountriesgroupsfromuser?api-version=1.0`,
      listCountries,
    )
    return result
  },
  switchaccountenabled: async (data) => {
    return await switchaccountenabled(data)
  },
}

export default usersService
